module.exports = __webpack_public_path__ + "img/SKMJ_heavy11.93c953ed.jpg";